export const eventsData = [
    {
        id: 1,
        title: "SUMMER ART CLASSES FOR KIDS",
        Detail1: "Mon, Jan 8, 2024 - Thu, Jan 25, 10.00 AM to 12.30 PM",
        Detail2: "at Tvisart Studio",
        fromDay: "8",
        fromMonth: "Jan 24",
        tillDate: "2024-01-25",
        tillText: "till 25 Jan",
        description: "Join us for an exciting and creative journey at our Holiday Art Classes! This in-person program is specially designed for kids and teens, offering a vibrant space to explore fun-filled art and craft activities. From playful experiments to guided projects, young artists will have the chance to express themselves, learn new techniques, and enjoy a truly hands-on creative experience.",
        images: [
            "kids.jpg",
        ]
    },
    {
        id: 2,
        title: "CANVAS PAINTING DEMONSTRATION",
        Detail1: "Sat, Feb 4, 2024, 10.00 AM to 02.00 PM",
        Detail2: "at Women's Community Centre, Stepney",
        fromDay: "4",
        fromMonth: "Feb 24",
        tillDate: "2024-02-04",
        description: "Come and enjoy a live canvas-painting demonstration at the Women's Community Centre in Stepney. I'll be sharing techniques, creative tips, and the joy of bringing a painting to life right before your eyes. It's a wonderful opportunity to relax, connect, and explore the artistic process together.",
        images: [
            "demo_wcc.jpg",
        ]
    },
    {
        id: 3,
        title: "ARTSY TUESDAYS WITH SANDHYA",
        Detail1: "Tue, Feb 20, 2024 to Tue, Mar  26, 4.00 PM to 05.30 PM",
        Detail2: "at Women's Community Centre, Stepney",
        fromDay: "20",
        fromMonth: "Feb 24",
        tillDate: "2024-03-26",
        tillText: "till 26 Mar",
        description: "Join our art class and explore a diverse range of creative options, including canvas painting, watercolours, mandala art, pencil shading, mixed media, coffee painting, and more. Our exclusive ladies-only batch offers a welcoming space to dive into new techniques and artistic possibilities. With comprehensive guidance throughout each session, you'll build confidence and master the art of painting.",
        images: [
            "wcc.jpg",
        ]
    },
    {
        id: 4,
        title: "FUNDAMENTAL OF WATERCOLORS WEEKLY CLASS",
        Detail1: "Thurs, Mar 7, 2024 to Thu, May 30, 11.00 AM to 12.30 PM",
        Detail2: "at Tvis Arts Studio",
        fromDay: "7",
        fromMonth: "Mar 24",
        tillDate: "2024-05-30",
        tillText: "till 30 May",
        description: "Delve into the essence of watercolours, where artistry meets fluidity and every stroke carries its own story. This 12-week course introduces the foundational principles that make the medium so captivating. You'll explore transparency and layering, water control, colour mixing, brush techniques, wet-on-wet and wet-on-dry methods, washes, glazing, masking, and many more skills that build confidence and creative freedom.",
        images: [
            "water1.jpg",
            "water.jpg",
        ]
    },
    {
        id: 5,
        title: "INDIAN MADHUBANI ART DEMONSTRATION AND WORKSHOP",
        Detail1: "Fri, Jul 5, 2024, 11.00 AM to 02.00 PM",
        Detail2: "at Port Adelaide Football Club",
        fromDay: "5",
        fromMonth: "Jul 24",
        tillDate: "2024-07-05",
        description: "I'm excited to present a Madhubani art demonstration and workshop at the Port Adelaide Football Club's multicultural event. I'll showcase this ancient Indian folk style and invite students to help create a collaborative Madhubani-themed canvas. Come explore a vibrant traditional art form in a fun, hands-on way.",
        images: [
            "madhu1.jpg",
            "madhu.jpg",
        ]
    },
    {
        id: 6,
        title: "SEED IN GANESHA IDOL MAKING WORKSHOP",
        Detail1: "Sat, Aug 17, 2024, 10.00 AM to 11.30 AM & 12.00 PM to 01:30 PM",
        Detail2: "Organised by UIOSA at Model T Ford Club",
        fromDay: "17",
        fromMonth: "Aug 24",
        tillDate: "2024-08-17",
        description: "Rebirth of Nature with Plant Ganesha. Celebrate Ganesh Chaturthi the eco-friendly way by crafting a clay Ganesha idol. These sustainable idols promote environmental awareness and set a positive example for future generations. Immersion becomes simple and meaningful—just a bucket of water in your own backyard. This thoughtful approach resonates deeply with people, allowing us to honour the festival while caring for the planet.",
        images: [
            "ganesha.jpg",
        ]
    },
    {
        id: 7,
        title: "ARTIST TALK - EXPLORING THE FABRIC OF MAKING",
        Detail1: "SALA GROUP EXHIBITION",
        Detail2: "Artist talk - 01.00 PM, Demonstration all day",
        fromDay: "18",
        fromMonth: "Aug 24",
        tillDate: "2024-08-18",
        Description: "Please join us for our SALA festival group exhibition, Exploring the Fabric of Making, featuring works by Catherine Fitz-Gerald, Sandhya Mulchandani, and Swapna Namboodiri. I'll be demonstrating my Bas-relief art and sharing insights into this ancient art-form during my talk this Sunday. Hope to see you there!",
        images: [
            "talk.jpg",
            "demo.jpg",
        ]
    },
    {
        id: 8,
        title: "EXPLORING THE FABRIC OF MAKING",
        Detail1: "SALA GROUP EXHIBITION",
        Detail2: "Sun, Aug 11, Sun Aug 18 & Sun Aug 25,  2024",
        fromDay: "11",
        fromMonth: "Aug 24",
        tillDate: "2024-08-25",
        tillText: "till 25 Aug",
        description: "I'm thrilled to be part of Exploring the Fabric of Making, a SALA Festival group exhibition featuring works by Catherine Fitz-Gerald, Sandhya Mulchandani, and Swapna Namboodiri. This showcase brings together three distinct creative voices connected by a shared curiosity for process, material, and storytelling. It also marks my first SALA exhibition since relocating to Adelaide in September 2023, making this moment especially meaningful as I continue to find my place within South Australia's vibrant arts community.",
        images: [
            "sala1.jpg",
            "sala2.jpg",
        ]
    },
    {
        id: 9,
        title: "AUSTRALIA CHA RAJA REPLICA IDOL MAKING",
        Detail1: "Sat, Sep 7, 2024 & Sun, Sep 8, 2024, full day event",
        Detail2: "Organised by UIOSA at The Parks, Angle Park",
        fromDay: "7",
        fromMonth: "Sep 24",
        tillDate: "2024-09-08",
        tillText: "& 8 Sep",
        description: "Come and witness the making of a replica of \"Australia Cha Raja,\" a terracotta Ganesha idol, at the Art & Culture Ganesh Festival organised by UIOSA. I will be sculpting and painting the idol live at the event, and I'd love for you to be part of the experience.",
        images: [
            "idol.jpg",
        ]
    },
    {
        id: 10,
        title: "OWN THE MOON",
        Detail1: "Nature Festival Textured Art Workshopk",
        Detail2: "Wed, Oct 2, 2024 & Sat, oct 5, 2024, 10.00 AM to 12.00 PM",
        fromDay: "2",
        fromMonth: "Oct 24",
        tillDate: "2024-10-05",
        tillText: "& 5 Oct",
        description: "Join us for an enchanting artistic journey where you can Own the Moon! In this hands-on workshop, you'll be guided in creating your very own textured moon art piece, featuring a captivating dome effect and lights to bring your moon to life.",
        images: [
            "moon.jpg",
        ]
    },
    {
        id: 11,
        title: "WALKERVILLE ART SHOW",
        Detail1: "Fri, Oct 4, 2024, 6.00 PM - Sat, Oct 12, 2024, 4.00 PM",
        Detail2: "Opening - Fri, Oct 4, 6.00 PM at St. Andrew's School",
        fromDay: "4",
        fromMonth: "Oct 24",
        tillDate: "2024-10-12",
        tillText: "till 12 Oct",
        description: "I am so excited to be participating in the Walkerville Art Show this year. It's a wonderful opportunity to share my work alongside a vibrant community of artists. I'd love for you to visit the exhibition, explore the diverse artworks on display and spend a moment with the piece I'm presenting.",
        images: [
            "walkerville.jpg",
        ]
    },
    {
        id: 12,
        title: "VICTOR HARBOR ART SHOW",
        Detail1: "Sat, Jan 11, 2025 - Sat, Jan 18, 2025, 09.30 AM to 8.00 PM",
        Detail2: "Pepper Street Art Center, Magill,",
        fromDay: "27",
        fromMonth: "Jan 25",
        tillDate: "2025-01-18",
        tillText: "till 18 Jan",
        Description: "The Victor Harbor Art Show is one of those events that turns a simple trip down the coast into something unforgettable, sun, sea, great food, a beach stroll, maybe even a winery detour—and of course an incredible showcase of art. I'm absolutely thrilled to be participating in 2025. Come down, make a day of it, and enjoy the art with me.",
        images: [
            "victor.jpg",
        ]
    },
    {
        id: 13,
        title: "BRIGHTON JETTY SCULPTURES",
        Detail1: "Wed, Jan 22, 2026, - Sun, Feb 2, 2026,  9.00 AM to 8.00 PM ",
        Detail2: "Opening - Thu, Jan 23, 2026, 07.00 PM",
        fromDay: "22",
        fromMonth: "Jan 25",
        tillDate: "2025-02-02",
        tillText: "till 02 Feb",
        description: "I'm excited to be part of the Brighton Jetty Sculpture Show this year. You'll find my work along the Brighton foreshore throughout the exhibition, with sculptures accessible to explore all day. I'd love for you to visit and spend a moment with the piece I'm showing.",
        images: [
            "brighton1.jpg",
        ]
    },
    {
        id: 14,
        title: "ADLAIDE FRINGE - ART OF STORY TELLING EXHIBITION",
        Detail1: "Sun, Feb 23, 2025 - Fri, Mar 21, 2025, 10.00 AM to 5.00 PM",
        Detail2: "Opening -Sun, Feb 23, 2025, 2.00 PM at Pepper Street Art Center",
        fromDay: "23",
        fromMonth: "Feb 25",
        tillDate: "2025-03-21",
        tillText: "till 21 Mar",
        description: "I'm delighted to be part of the Adelaide Fringe exhibition Art of Storytelling at Pepper Street Arts Centre, where my artwork A Love Story Carved in Marble is on display. This piece reflects the enduring love between Emperor Shah Jahan and his beloved queen, Mumtaz Mahal, a story that has inspired generations. I'd love for you to visit the exhibition, explore the many narratives brought to life by artists, and spend a moment with this tribute to one of history's most iconic love stories.",
        images: [
            "story.jpg",
        ]
    },
    {
        id: 15,
        title: "CAMBELLTOWN ART SHOW",
        Detail1: "Sat, May 10, 2025 - Sat, May 17, 2025, 10.00 AM to 04.30 PM",
        Detail2: "Opening - Fri, May 9, 2025, 07.30 PM at Cambelltown City Councill",
        fromDay: "10",
        fromMonth: "May 25",
        tillDate: "2025-05-17",
        tillText: "till 17 May",
        description: "I am so excited to be participating in the Cambelltown Art show group exhibition this year. It's a wonderful opportunity to share my work alongside a vibrant community of artists. I'd love for you to visit the exhibition, explore the diverse artworks on display and spend a moment with the piece I'm presenting.",
        images: [
            "cambelltown.png",
        ]
    },
    {
        id: 16,
        title: "SEED IN GANESHA IDOL MAKING WORKSHOP",
        Detail1: "Sun, Aug 10, 2025, 09.30 AM to 11.30 AM",
        Detail2: "Organised by UIOSA at Model T Ford Club",
        fromDay: "10",
        fromMonth: "Aug 25",
        tillDate: "2025-08-10",
        description: "Rebirth of Nature with Plant Ganesha. Celebrate Ganesh Chaturthi the eco-friendly way by crafting a clay Ganesha idol. These sustainable idols promote environmental awareness and set a positive example for future generations. Immersion becomes simple and meaningful—just a bucket of water in your own backyard. This thoughtful approach resonates deeply with people, allowing us to honour the festival while caring for the planet.",
        images: [
            "ganesha1.jpg",
        ]
    },
    {
        id: 17,
        title: "SALA GROUP EXHIBITION - WILD BY NATURE",
        Detail1: "Sun, Jul 27, 2025 - Fri, Aug 29, 2025, 10.00 AM to 5.00 PM",
        Detail2: "Pepper Street Art Center, Magill,",
        fromDay: "27",
        fromMonth: "Jul 25",
        tillDate: "2025-08-29",
        tillText: "till 29 Aug",
        description: "I'm delighted to have my bas-relief artwork Rustic Hop featured in Pepper Street's SALA exhibition Wild by Nature. This piece celebrates Australian kangaroos in their natural outback habitat, capturing the quiet rhythm and character of the landscape. Shown alongside works inspired by the wild world around us, the exhibition offers a lively mix of interpretations. If you visit, I'd love for you to spend a moment with Rustic Hop in this welcoming creative space.",
        images: [
            "pepper1.jpg",
            "pepper2.jpg",
        ]
    },
    {
        id: 18,
        title: "SALA @ THE SUMMIT GROUP EXHIBITION",
        Detail1: "Mon, Aug 4, 2025 - Thu, Sep 11, 2025, 9.00 AM to 3.00 PM",
        Detail2: "Opening -Fri, Aug 1, 2025, 4.00 PM at The Summit Community Center",
        fromDay: "4",
        fromMonth: "Aug 25",
        tillDate: "2025-09-11",
        tillText: "till 11 Sep",
        description: "I'm excited to be showing my work in SALA @ The Summit, a lively group exhibition set high in the Adelaide Hills. The space buzzes with creative energy, and it's a joy to have my relief pieces and sculptures included among such diverse artworks. If you're heading into the Hills during SALA, do stop by The Summit and enjoy the exhibition in this beautiful setting.",
        images: [
            "summit.jpg",
        ]
    },
    {
        id: 19,
        title: "SALA GROUP EXHIBITION",
        Detail1: "Opening Thu, Aug 7, 2025, 7.00 PM",
        Detail2: "Art Expression @ 123 Fisher, Fullarton",
        fromDay: "9",
        fromMonth: "Aug 25",
        tillDate: "2025-08-30",
        tillText: "till 30 Aug",
        description: "I am so excited to be participating in the Art Expression SALA group exhibition this year. It's a wonderful opportunity to share my work alongside a vibrant community of artists. I'd love for you to visit the exhibition, explore the diverse artworks on display and spend a moment with the piece I'm presenting.",
        images: [
            "fisher.jpg",
        ]
    },
    {
        id: 20,
        title: "SALA GROUP EXHIBITION",
        Detail1: "Wed, Aug 27, 2025 -  Sun, Sep 7, 2025, 10.00 AM to 4.00 PM",
        Detail2: "Duthy Street Art Supplie, Unley,",
        fromDay: "27",
        fromMonth: "Aug 25",
        tillDate: "2025-09-07",
        tillText: "till 07 Sep",
        description: "Step into the enchanting world of bas relief Australian bird sculptures. This exhibition brings together vibrant, story rich works that celebrate the beauty of nature through form, pattern and colour. Presented alongside the wonderful creations of Catherine Fitz-Gerald and Swapna Namoodiri, it offers a shared showcase of artists inspired by the natural world and the stories it carries.",
        images: [
            "sala3.jpg",
            "sala4.jpg",
        ]
    },
    {
        id: 21,
        title: "TIMELESS ART OF BAS-RELIEF : KINGFISHER'S HAVEN WORKSHOP",
        Detail1: "SALA Workshop Across Two Evenings",
        Detail2: "Wed, Aug 27, 2025 & Wed, Sep 3, 2025, 4.00 PM to 6.00 PM",
        fromDay: "27",
        fromMonth: "Aug 25",
        tillDate: "2025-09-03",
        tillText: "& 03 Sep",
        description: "Sculpt and paint a beautiful bas-relief kingfisher over two creative sessions. Open to all skill levels, this workshop brings together an ancient Indian art form, an Australian subject and contemporary techniques. Join in and bring Kingfisher's Haven to life this SALA Festival.",
        link: "https://bit.ly/3TnI8A6",
        images: [
            "bas-relief.jpg",
            "workshop1.jpg",
        ]
    },
    {
        id: 22,
        title: "JAMESTOWN SCULPTURE ART FESTIVAL",
        Detail1: "Mon, Sep 22, 2025, 10.00 AM - Sat, Oct 11, 2025, 4.00 PM",
        Detail2: "at Jamestown Memorial Hall",
        fromDay: "22",
        fromMonth: "Sep 25",
        tillDate: "2025-10-11",
        tillText: "till 11 Oct",
        description: "I'm thrilled to be part of the Jamestown Sculpture Festival in the beautiful Clare Valley region. It's an exciting chance to share my relief work and sculptures with visitors as they explore this lively arts event. If you're heading through the valley, I'd love for you to drop in, wander among the artworks and spend a moment with the pieces I'm exhibiting.",
        images: [
            "jamestown.jpg",
        ]
    },
    {
        id: 23,
        title: "WALKERVILLE ART SHOW",
        Detail1: "Fri, Oct 3, 2025, 6.00 PM - Sat, Oct 11, 2025, 4.00 PM",
        Detail2: "Opening - Fri, Oct 3, 6.00 PM at St. Andrew's School",
        fromDay: "3",
        fromMonth: "Oct 25",
        tillDate: "2025-10-11",
        tillText: "till 11 Oct",
        description: "I am so excited to be participating in the Walkerville Art Show this year. It's a wonderful opportunity to share my work alongside a vibrant community of artists. I'd love for you to visit the exhibition, explore the diverse artworks on display and spend a moment with the piece I'm presenting.",
        images: [
            "walkerville.jpg",
        ]
    },
    {
        id: 24,
        title: "Judge: Rangoli and Kids' Drawing Competition",
        Detail1: "at Diwali mela by Hindu Council of Australia",
        fromDay: "4",
        fromMonth: "Oct 25",
        tillDate: "2025-10-04",
        description: "I was recently invited to serve as a judge for a Rangoli competition and a children's drawing competition, a role that allowed me to celebrate the creativity and imagination of the community. It was a joy to witness the vibrant designs, thoughtful ideas and the enthusiasm each participant brought to their work. I'm grateful for the opportunity to support and encourage young and emerging artists.",
        images: [
            "judge.jpg",
        ]
    },
    {
        id: 25,
        title: "BRIGHTON JETTY SCULPTURES",
        Detail1: "Wed, Jan 21, 2026, 9.00 AM - Sun, Feb 1, 2026, 8.00 PM ",
        Detail2: "Opening - Thu, Jan 22, 2026, 07.00 PM",
        fromDay: "21",
        fromMonth: "Jan 26",
        tillDate: "2026-02-01",
        tillText: "till 01 Feb",
        description: "I'm excited to be part of the Brighton Jetty Sculpture Show this year. You'll find my work along the Brighton foreshore throughout the exhibition, with sculptures accessible to explore all day. I'd love for you to visit and spend a moment with the piece I'm showing.",
        images: [
            "brighton.jpg",
        ]
    },
    {
        id: 26,
        title: "SMRITI SUTRA: SCULPTING STORIES AND MYTHS",
        Detail1: "A solo exhibition of paper mâché sculptures inspired by Gond tribal lore and Indian mythology",
        Detail2: "Opening - Sat, Mar 7, 2026, 2.00 PM",
        fromDay: "7",
        fromMonth: "Mar 26",
        tillDate: "2026-04-19",
        tillText: "till 19 Apr",
        description: "You're warmly invited to Smriti Sutra, an exhibition shaped by the stories that coloured my childhood. These were the tales I grew up listening to, filled with mythic birds, spirited beings, and whispered memories, and they now return as sculpted forms alive with pattern, colour, and play. I'd love for you to step into this world of remembered stories and see how they've taken shape in the sculptures now ready to meet you.",
        images: [
            "smriti1.jpg",
            "smriti2.jpg"
        ]
    },
    {
        id: 27,
        title: "WEAVING TALES WITH GOND MOTIFS — A GOND ART WORKSHOP",
        Detail1: "Sat, Apr 11, 2026,",
        Detail2: "10.00 AM to 1.00 PM",
        fromDay: "11",
        fromMonth: "Apr 26",
        tillDate: "2026-04-11",
        description: "Join me for a hands-on exploration of Gond art where stories spring from pattern, colour and imagination. In this workshop we'll dive into the playful spirit of tribal motifs and create our own vibrant artworks inspired by nature and myth. Whether you're new to Gond or simply curious, come discover how simple lines can weave powerful tales and leave with a piece that's uniquely yours.",
        link: "https://www.trybooking.com/events/landing/1517414",
        images: [
            "workshop.jpg",
        ]
    },
    {
        id: 28,
        title: "SALA @ MITCHAM LIBRARY - NATURE IN CLAY & COLOR",
        Detail1: "Witness Australian wildlife and flora in bas-relief and sculpture brought alive through texture and expression.",
        Detail2: "Opening - Thu, Aug 6, 2026,6.00 PM",
        fromDay: "1",
        fromMonth: "Aug 26",
        tillDate: "2026-08-31",
        tillText: "till 31 Aug",
        location: "Mitcham Memorial Library - 154 Belair Road Hawthorn SA 5062",
        locationLink: "https://maps.app.goo.gl/qrjgGw4Enm7DQnt7A",
        description: "You are warmly invited to explore Australian wildlife and flora through bas-relief and sculptural works that celebrate texture, storytelling, and the quiet poetry of nature. Presented at Mitcham Memorial Library, this SALA exhibition brings together hand‑crafted reliefs shaped in clay and color, each piece reflecting the rhythms, patterns, and living spirit of Australia’s landscapes. Designed for an accessible, community‑centered space, the exhibition invites viewers to pause, observe, and connect with the intricate details that define the country’s natural heritage.",
        link: "https://www.eventbrite.com.au/e/meet-the-artists-explore-sala-exhibition-mitcham-memorial-library-tickets-1987286217573",
        images: [
            "library.jpg",
        ]
    },
    {
        id: 29,
        title: "WEAVING TALES WITH GOND MOTIFS — A GOND ART WORKSHOP",
        Detail1: "Sat, Aug 5, 2026",
        Detail2: "5.30pm to 7.30pm",
        fromDay: "5",
        fromMonth: "Aug 26",
        tillDate: "2026-08-05",
        location: "Mitcham Memorial Library - 154 Belair Road Hawthorn SA 5062",
        locationLink: "https://maps.app.goo.gl/qrjgGw4Enm7DQnt7A",
        description: "Discover the intricate and imaginative world of Gond tribal art, the traditional art form of the Gond, an Indigenous community of India. In this workshop, participants explore how simple lines and patterns, drawn from nature and mythology, can unfold into vibrant stories. Guided through the process, they create and paint a Gond‑inspired artwork based on their own story on canvas and leave with a finished canvas alive with colour, pattern, and narrative.",
        link: "https://www.eventbrite.com.au/e/weaving-tales-with-gond-motifs-a-gond-art-tickets-1987470188836",
        images: [
            "gond.jpg",
        ]
    },
    {
        id: 30,
        sortId: 1,
        title: "SALA @ TVISARTS STUDIO - SHAPING ISLANDS, SHAPING STORIES",
        Detail1: "Sculptural worlds shaped from paper, memory, and folk rhythm. These textured forms trace stories of land, pattern, and emerging island ecologies within my evolving practice",
        Detail2: "Exhibition dates: 15th August - 23rd August, Saturday & Sunday, 11am - 3pm ",
        fromDay: "15",
        fromMonth: "Aug 26",
        tillDate: "2026-08-23",
        tillText: "till 23 Aug",
        location: "TvisArt Studio - 43 Phillis street Maylands SA 5069",
        locationLink: "https://maps.app.goo.gl/U5iAzLbrRe5SxdvM8",
        description: "Shaping Islands, Shaping Stories brings together my evolving sculptural practice—papier-mâché Gond-inspired forms, rooted in the Indigenous tribal art traditions of central India, and narrative bas‑relief works shaped by memory, pattern, and folk rhythm. This exhibition offers an intimate look at the worlds I build through paper, clay, and story, tracing the threads that connect land, imagination, and lived experience.",
        images: [
            "sala2026_front.jpg",
            "sala2026_back.jpg", 
        ]
    },
    {
        id: 31,
        sortId: 2,
        title: "OPEN STUDIO — PAPER MACHE SCULPTURE DEMONSTRATION",
        Detail1: "Experience the slow, tactile art of paper-mâché through a live sculpture demonstration.",
        Detail2: "Sat 15th & Sun 16th Aug, 11.30am - 2.30pm",
        fromDay: "15",
        fromMonth: "Aug 26",
        tillDate: "2026-08-16",
        tillText: "& 16 Aug",
        location: "TvisArt Studio - 43 Phillis street Maylands SA 5069",
        locationLink: "https://maps.app.goo.gl/U5iAzLbrRe5SxdvM8",
        description: "Come to my home studio, enjoy a cuppa, and watch paper-mâché come alive—forms rising from raw material, textures unfolding under patient hands, and stories surfacing slowly in the vibrant language of Gond Indigenous art. Settle into the rhythm of making, feel the intimacy of the process, and witness how each sculpture gathers its character through touch, pattern, and quiet narrative.",
        images: [
            "paper.jpg",
        ]
    },
        {
        id: 32,
        sortId: 3,
        title: "SHAPING ISLANDS IN CLAY — COMMUNITY PARTICIPATION",
        Detail1: "Sat 22nd & Sun 23rd Aug, 11.30am - 2.30pm",
        Detail2: "Age - 8+, No booking required",
        fromDay: "22",
        fromMonth: "Aug 26",
        tillDate: "2026-08-23",
        tillText: "& 23 Aug",
        location: "TvisArt Studio - 43 Phillis street Maylands SA 5069",
        locationLink: "https://maps.app.goo.gl/U5iAzLbrRe5SxdvM8",
        description: "Join me to shape clay islands as we think with our hands and reflect on Australia's 8,222 vulnerable island environments. These handmade islands will contribute to Error 404: Islands Not Found, a collaborative community art project with Catherine Fitz-Gerald and Swapna Namboodiri for exhibition in 2027. As rising sea levels threaten island ecosystems, this hands-on process creates a personal connection to environmental change, inviting participants to learn, share, and reflect together through free, inclusive workshops. Emphasising local action with global impact, the project encourages small community-led responses while offering a quiet, thoughtful space to engage with climate change.",
        images: [
            "island.jpg",
        ]
    },
    {
        id: 33,
        sortId: 4,
        title: "CLAY GANESHA IDOL MAKING WORKSHOP",
        Detail1: "Sat, Aug 29, 2026, 10.30am to 12 pm",
        Detail2: "Age - 8+, Booking required",
        fromDay: "29",
        fromMonth: "Aug 26",
        tillDate: "2026-08-29",
        location: "TvisArt Studio - 43 Phillis street Maylands SA 5069",
        locationLink: "https://maps.app.goo.gl/U5iAzLbrRe5SxdvM8",
        description: "In this hands-on cultural workshop, participants will create an 8-inch eco-friendly terracotta Ganesha idol using simple clay-building techniques. Inspired by 'Rebirth of Nature with Plant Ganesha,' the process blends tradition, sustainability, and gentle environmental awareness.",
        link: "https://events.humanitix.com/ganesha ",
        images: [
            "ganesha_sala.jpg",
        ]
    },
];